import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Container from 'react-bootstrap/Container'
import Button from 'react-bootstrap/Button'

// See https://reactjs.org/docs/error-boundaries.html
const withErrorBoundary = (WrappedComponent) => {
  class WithErrorBoundary extends Component {
    constructor() {
      super()

      this.state = {
        error: null,
        errorInfo: null,
      }
    }

    componentDidCatch(error, errorInfo) {
      this.setState({
        error,
        errorInfo,
      })
    }

    render() {
      const { error } = this.state
      const { ...rest } = this.props

      return (
        <>
          {error ? (
            <>
              <Container fluid className="d-flex flex-column flex-fill align-items-center justify-content-center">
                <div className="d-inline-block rounded-circle p-4">
                  <FontAwesomeIcon className="text-danger" style={{ fontSize: '250px' }} icon={['fas', 'exclamation-circle']} />
                </div>
                <h2 className="mt-2 text-secondary">Something went terribly wrong</h2>
                <h2>
                  <Button variant="link" onClick={() => window.location.reload()} style={{ fontSize: 'inherit' }}>
                    Take me outta here!
                  </Button>
                </h2>
              </Container>
            </>
          ) : (
            <WrappedComponent {...rest} />
          )}
        </>
      )
    }
  }

  return WithErrorBoundary
}

export default withErrorBoundary
